import { createContext } from 'react';

export interface FavoritesContextType {
  favorites: Set<string>;
  toggleFavorite: (id: string, collectionId: number) => Promise<void>;
  isFavorite: (id: string) => boolean;
  refreshFavorites: () => Promise<void>;
}

export const FavoritesContext = createContext<FavoritesContextType>({
  favorites: new Set(),
  toggleFavorite: () => Promise.resolve(),
  isFavorite: () => false,
  refreshFavorites: () => Promise.resolve(),
});
